/**
 * Return a hash number for a string. Based on the Java String.hashCode()
 *
 * Original version from:
 * https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 *
 *
 * @param {*} targetString
 */
export default function hash(target) {
    if (typeof target === 'string') return hashString(target);
    return hashObject(target);
}

/**
 * Return a hash number for an object.
 *
 * @param {*} obj
 */
export function hashObject(obj) {
    const objStr = Object.keys(obj)
        .reduce((arr, k) => {
            const v = obj[k];
            if (typeof v === 'object' && v !== null) {
                arr.push(`${k}:${hashObject(v)}`);
                return arr;
            }
            if (typeof v === 'symbol') {
                arr.push(`${k}:${v.toString()}`);
                return arr;
            }

            arr.push(`${k}:${obj[k]}`);
            return arr;
        }, [])
        .join(',');

    return hashString(objStr);
}

export function hashString(str) {
    let hashCode = 0,
        i,
        character;
    if (str.length === 0) return hashCode;
    for (i = 0; i < str.length; i++) {
        character = str.charCodeAt(i);
        hashCode = (hashCode << 5) - hashCode + character;
        hashCode |= 0;
    }
    return hashCode;
}
